import http from "./HttpService";

const endpoint = process.env.VUE_APP_BASE_URL;

export const fetchVouchers = (params) => {
  return http.get("/ReferralVouchers/vouchers/page/" + params.page, {
    baseURL: endpoint,
    params,
  });
};

export const storeVoucher = (data) => {
  return http.post("ReferralVouchers/create", data, {
    baseURL: endpoint,
  });
};

export const updateVoucher = (data) => {
  return http.put(`ReferralVouchers/vouchers/${data.voucher}`, data, {
    baseURL: endpoint,
  });
};

